
import { computed, defineComponent, PropType } from 'vue';
import dayjs from 'dayjs';
import { ChangeLogType } from '../type';
import ChangeLogSection from './ChangeLogSection.vue';

export default defineComponent({
  components: { ChangeLogSection },
  props: {
    changeLog: { type: Object as PropType<ChangeLogType>, required: true },
  },
  setup(props) {
    const formattedDate = computed(() => dayjs(props.changeLog.date).format('YYYY-MM-DD'));

    return {
      formattedDate,
    };
  },
});
